import { MailboxType } from 'owa-client-ids';
import { getIsSearchTableShown } from 'owa-mail-list-store';
import { isFolderUnderArchiveRoot } from 'owa-mail-store';
import folderNameToId from 'owa-session-store/lib/utils/folderNameToId';
import { isFolderOfTreeType, SHARED_FOLDERS_TREE_TYPE } from 'owa-folders';
export default function doesTableSupportUndo(sourceFolderId, mailboxInfo) {
    return (!getIsSearchTableShown() &&
        mailboxInfo &&
        mailboxInfo.type === MailboxType.UserMailbox &&
        !isFolderUnderArchiveRoot(sourceFolderId) &&
        sourceFolderId != folderNameToId('recoverableitemsdeletions') &&
        !isFolderOfTreeType(sourceFolderId, SHARED_FOLDERS_TREE_TYPE) /* shared folder items do not support undo */);
}
//# sourceMappingURL=doesTableSupportUndo.js.map